// extracted by mini-css-extract-plugin
module.exports = {"container":"_0fce717cdb--container--zCriI","tooltip-container":"_0fce717cdb--tooltip-container--NrnyN","title":"_0fce717cdb--title--tDi9B","text":"_0fce717cdb--text--BJO_p"};